import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Perfil Google',
  sections: {
    current_profile: {
      [mode_view]: 'Perfil ligado',
      [mode_edit]: 'Alterar perfil ligado',
    },
  },
  form: {
    google_places_id: {
      label: 'Nome no Google Maps',
    },
    address: {
      label: 'Morada',
    },
    rating: {
      label: 'Avaliação',
    },
    opening_hours: {
      label: 'Horário de funcionamento',
    },
    phone_number: {
      label: 'Número de telefone',
    },
    pictures: {
      label: 'Imagens',
    },
  },
  labels: {
    no_place_connected: 'Este restaurante não tem nenhum perfil Google ligado',
    fields_to_sync: 'Informação a sincronizar de {{name}}',
  },
  buttons: {
    save: 'Guardar',
    change: 'Alterar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
